'use client'

import { useRouter } from 'next/navigation'

import { useAppSelector } from './useRedux'

export const useCheckLogin = () => {
  //
  const router = useRouter() // Khai baáo router  dunùng để chuyeênển trang
  const user = useAppSelector((state) => state.root.auth.user) // Lấy id của user
  const pathname = window.location.href
  const currentPath = localStorage.getItem('current-path')

  if (!user) {
    localStorage.setItem('current-path', pathname)
    router.push('/sign-in')
    return
  }
  if (!user?.isActive) {
    router.push('/create-profile')
    return
  }
  if (currentPath) {
    localStorage.removeItem('current-path')
    return
  }
}
